/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CurrentUserView from './current-user-view';
import { AdminService } from '../../services/requests';
import { changeDataById } from '../../store/users';

const CurrentUserContainer = (props) => {
  const [userData, setUserData] = useState();
  const [userDataLoading, setUserDataLoading] = useState(false);
  const [companyData, setCompanyData] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [userСastingsLoading, setUserСastingsLoading] = useState(false);
  const [userCastings, setUserCastings] = useState();
  const [fullVLoader, setFullVLoader] = useState(false);

  const renderCategoriesObject = (arr) => {
    const interestsArr = [];
    if (props.categories.success) {
      for (let i = 0; i < props.categories.data.length; i += 1) {
        for (let childrenIndex = 0; childrenIndex < props.categories.data[i].children.length; childrenIndex += 1) {
          for (let index = 0; index < arr.length; index += 1) {
            if (props.categories.data[i].children[childrenIndex].id === arr[index]) {
              interestsArr.push(props.categories.data[i].children[childrenIndex]);
            }
          }
        }
      }
      return interestsArr;
    }
  };

  const getUserData = async () => {
    setUserDataLoading(true);
    try {
      const res = await AdminService.getUserDataByUid(props.history.location.hash.replace('#', ''));

      if (res) {
        setUserData(res);
        if (res.companyData) {
          setCompanyData([res.companyData]);
        }
        if (res.companiesIds) {
          const companyArray = [];
          for (let i = 0; i < res.companiesIds.length; i += 1) {
            const response = await AdminService.getCompany(res.companiesIds[i]);
            companyArray.push(response);
          }
          setCompanyData(companyArray);
        }
        setUserDataLoading(false);
      }
    } catch (err) {
      console.log(err);
      setUserDataLoading(true);
    }
  };

  const refreshAction = () => {
    if (activeTab === 0) {
      getUserData();
    }
    if (activeTab === 1) {
      if (userData.role === 'applicant') {
        checkUserCasting();
      } else {
        getEmployerCastings();
      }
    }
  };

  const checkUserCasting = async () => {
    setUserСastingsLoading(true);
    try {
      const res = await AdminService.getApplicantCastings(props.history.location.hash.replace('#', ''));

      if (res) {
        setUserCastings(res);
        setUserСastingsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setUserСastingsLoading(true);
    }
  };

  const getEmployerCastings = async () => {
    setUserСastingsLoading(true);
    try {
      const res = await AdminService.getEmployerCastings(props.history.location.hash.replace('#', ''));

      if (res) {
        setUserCastings(res);
        setUserСastingsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setUserСastingsLoading(true);
    }
  };

  const giveOutFullVersion = async (userId) => {
    setFullVLoader(true);
    try {
      const res = await AdminService.giveOutFullVersion({ userId });

      if (res) {
        props.changeDataById({
          key: `${userData.role}s`,
          id: userData.uid,
          data: res,
        });
        setUserData(res);
        setFullVLoader(false);
      }
    } catch (err) {
      console.log(err);
      setFullVLoader(false);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
    if (activeTab === 1 && userCastings === undefined && userData.role === 'applicant') {
      checkUserCasting();
    } else if (activeTab === 1 && userCastings === undefined) {
      getEmployerCastings();
    }
  }, [activeTab]);

  return (
    <CurrentUserView
      giveOutFullVersion={giveOutFullVersion}
      renderCategoriesObject={renderCategoriesObject}
      setActiveTab={setActiveTab}
      userDataLoading={userDataLoading}
      userData={userData}
      activeTab={activeTab}
      userСastingsLoading={userСastingsLoading}
      userCastings={userCastings}
      fullVLoader={fullVLoader}
      categories={props.categories}
      refreshAction={refreshAction}
      companyData={companyData}
    />
  );
};

CurrentUserContainer.propTypes = {
  history: PropTypes.object,
  categories: PropTypes.object,
  changeDataById: PropTypes.func,
};
CurrentUserContainer.defaultProps = {
  history: {},
  categories: {},
  changeDataById: () => {},
};

const mapStateToProps = (state) => ({
  categories: state.categories,
  users: state.users.roles,
});

const mapDispatchToProps = (dispatch) => ({
  changeDataById: (payload) => dispatch(changeDataById(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CurrentUserContainer);
